import React, {useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { styled } from '@mui/system'
import { Item } from '../../../common/snippets'
import BranchRechargeReportNew from './BranchRechargeReportNew'
import PartyRechargeReport from './PartyRechargeReport'
import { RechargeHistoryPageTabIds, rechargeHistoryPageTabs } from './constant'
import { ReportHeading } from '../common/ReportHeading'

const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    height: 4,
    backgroundColor: theme.palette.primary.main,
  },
}))

const RechargeHistoryReport = () => {
  const [selectedTab, setSelectedTab] = useState(0)

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  return (
    <Item sx={{ padding: '0' }} className="reports">
      <ReportHeading reportName={'Reacharge History'} />
      <Box className="RechargeHistoryPageTabContainer">
        <Item sx={{ padding: 0 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <StyledTabs
              aria-label="basic tabs example"
              value={selectedTab}
              onChange={handleTabChange}
              sx={{ backgroundColor: '#e5f3fe', height: '30px', minHeight: '37px', border: 'none', padding: '0 24px' }}
            >
              {rechargeHistoryPageTabs.map((tab, index) => (
                <Tab
                  sx={{
                    minHeight: '30px',
                    height: '30px',
                    '&.Mui-selected': {
                      border: 'none',
                      minHeight: '30px',
                      height: '30px',
                    },
                  }}
                  key={tab.JobID}
                  label={tab.name}
                  {...RechargeHistoryPageTabIds(tab.JobID)}
                />
              ))}
            </StyledTabs>
          </Box>

          <Box sx={{ p: 3 }}>{(selectedTab === 0 && <BranchRechargeReportNew />) || (selectedTab === 1 && <PartyRechargeReport />)}</Box>
        </Item>
      </Box>
    </Item>
  )
}

export default RechargeHistoryReport
